import TeamCard from "./TeamCard.jsx";

export default TeamCard;